import { render } from "./login.vue?vue&type=template&id=01275f20&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=01275f20&scoped=true&lang=css"
import "./login.vue?vue&type=style&index=1&id=01275f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01275f20"]])

export default __exports__